import styled from "styled-components"

// Page Container
const PageContainerComponent = styled.section`
    display: grid;
    justify-content: center;
    align-content: start;
    width: 100%;
    height: 75vh;
    overflow-x: hidden;
    white-space: nowrap; 
`
export const PageContainer = (props)=>{
    return(
        <PageContainerComponent>
            {props.children}
        </PageContainerComponent>
    )
}